module.exports = __webpack_public_path__ + "img/logo-vetorart.6d685529.webp";